import adminApi from '@/api/admin/adminClient';
import { ENDPOINTS } from '@/api/endpoints';
import type { ApiEnvelope, AuthUser } from '@/types/dashboard/auth';

export const authApi = {
  async login(username: string, password: string): Promise<AuthUser> {
    // Sets the csrftoken cookie; must finish before the POST below
    await adminApi.get(ENDPOINTS.admin.auth.csrf);
    const { data } = await adminApi.post<ApiEnvelope<AuthUser>>(ENDPOINTS.admin.auth.login, {
      username,
      password,
    });
    return data.data;
  },

  async logout(): Promise<void> {
    await adminApi.post(ENDPOINTS.admin.auth.logout);
  },
};